module.exports = __webpack_public_path__ + "img/745.a2d327aa.png";